<template>
  <auth-page>
    <div slot="content">
      <form @submit.prevent="request()">
        <b-field label="Nieuwe wachtwoord">
          <b-input v-model="password" type="password" />
        </b-field>
        <button class="button big is-info is-fullwidth" type="is-primary">Veranderen</button>
      </form>
    </div>
  </auth-page>
</template>

<script>
import ApiService from "@/common/api.service";
import router from "@/router";
import AuthPage from "../components/AuthPage.vue";

export default {
  components: { AuthPage },
  name: "RequestPassword",
  props: ["code"],
  data() {
    return {
      password: "",
    };
  },
  methods: {
    async request() {
      let response = await ApiService.post("user/resetpassword/" + this.code, {
        password: this.password,
      });
      if (response.data) {
        this.$buefy.toast.open({
          message:
            "Je wachtwoord is veranderd, je kunt inloggen met je nieuwe gegevens",
          type: "is-success",
        });
        this.$router.push("/login");
      } else {
        this.$buefy.toast.open({
          message: "Deze link is ongeldig of al gebruikt",
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  a {
    color: #fff !important;
  }
}
.section {
  width: 50%;
  margin: 0 auto;
  flex-direction: column;
  -webkit-transition: width 0.5s;
  transition: width 0.5s;
  padding: 0 40px !important;
  form {
    width: 100%;
  }
}
@media screen and (max-width: 1300px) {
  .section {
    width: 70%;
  }
}
@media screen and (max-width: 1100px) {
  .section {
    width: 100%;
  }
}
@media screen and (max-width: 768px) {
  .section {
    width: 70%;
  }
}
@media screen and (max-width: 600px) {
  .section {
    width: 100%;
  }
}
</style>
